import {
    Component,
    OnInit
} from '@angular/core';
import {
    ActivatedRoute, Router
} from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowEndcustomerService } from '../workflow-endcustomer.service';
import { WorkflowComponent } from '../../workflow.component';
import { firstValueFrom } from 'rxjs';
import { SaleOrder } from 'src/app/buy/buy.model';


@Component({
    selector: 'app-workflow-endcustomer-one-availability-order-cancel',
    templateUrl: './workflow-endcustomer-one-availability-order-cancel.component.html',
    standalone: false
})
export class WorkflowEndcustomerOneAvailabilityOrderCancelComponent extends WorkflowComponent implements OnInit {

    public applianceId: string;
    public subscription: Subscription;
    public readonly productPremium = "PC-ONE-PREMIUM";
    public readonly productCancelPremium = "PC-ONE-CANCEL-PREMIUM";
    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowEndcustomerService: WorkflowEndcustomerService
    ) {
        super();

    }


    ngOnInit() {
        super.ngOnInit();
        this.setStep('order-cancel');
        this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
            next: (r) => {
                this.subscription = Subscription.fromJson(r);
                this.applianceId = this.subscription.appliance_id;
                this.setStep('order-cancel');
            },
            error: (err) => {
                console.error('Failed to load subscription:', err);
                this.router.navigate(['/subscriptions']);
                this.resetWorkflow();
            }
        });
    }


    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        let hasPremium: boolean = false;
        let orderFound: SaleOrder;
        try {
            for (const order of this.subscription?.orders ?? []) {
                hasPremium = (order?.lines ?? []).some(
                    line => (line?.product === this.productPremium) 
                        || (line?.product === this.productCancelPremium)
                );
                if (hasPremium) {
                    orderFound = order;
                    break;
                }
            }
            if (hasPremium && orderFound) {
                await firstValueFrom(this.workflowEndcustomerService.oneApplianceCancelPremium(orderFound.name));
                this.resetWorkflow();
            } else {
                this.resetWorkflow();
            }
        } catch (e) {
            console.error('Cancel premium failed', e);
            this.resetWorkflow();
        }
    }
}
